import {
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { setSelectedServiceId, setSelectedStageId } from '../../store/actions/index';
import FormDialog from '../../../../components/table/FormDialog';
import CommentDeleting from '../OpenService/CommentDeleting';
import '../../servicestyles.css';
import { yearType } from '../../../../config/serviceYear';
import { userType } from '../../../../config/usertypeValue';

function EnhancedTableHead(props) {
    const { classes, headcells, order, orderBy, onRequestSort, action } = props;

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {headcells.map((headRow) => {
                    return (
                        <TableCell
                            className={classes.TableHeadCss}
                            key={headRow.id}
                            align="left"
                            sortDirection={orderBy === headRow.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}{' '}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}

                {action && (
                    <TableCell align="left" className={classes.TableHeadCss}>
                        Action
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
        padding: theme.spacing(2),
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        fontSize: '14px',
        color: '#31333F',
        backgroundColor: '#dcdcdc',
    },
    red: {
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 10px',
        textTransform: 'capitalize',
        fontFamily: 'Rubik',
    },
    green: {
        backgroundColor: 'green',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 6px',
        textTransform: 'capitalize',
        fontFamily: 'Rubik',
    },
    grey: {
        backgroundColor: 'grey',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 6px',
        textTransform: 'capitalize',
        fontFamily: 'Rubik',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tblAction: {
        '& button': {
            padding: '0',
            paddingRight: '10px',
            '&:last-child': {
                paddingRight: '0px',
            },
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    },
}));

function descendingComparator(a, b, orderBy) {
    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];
    if (y < x) {
        return -1;
    }
    if (x < y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => {
        return el[0];
    });
}

const ServiceTableClient = (props) => {
    const {
        headcells,
        action,
        rows,
        service,
        post,
        handleDelete,
        pageName,
        handleClickRow,
        handleCount,
        pageDetails,
        prvnxtbt,
    } = props;
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const history = useHistory();
    const dispatch = useDispatch({});
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const tennantName = tennantnameValue && tennantnameValue.toUpperCase();
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const classes = useStyles();

    useEffect(() => {
    }, []);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const actionButton = (actionButtonData, obj) => {
        dispatch(setSelectedServiceId(actionButtonData.servId));
        dispatch(setSelectedStageId(actionButtonData.statusId));
        let tempYear = '';
        rows.filter((ele) => {
            if (ele.serviceId === actionButtonData.servId) {
                tempYear = ele.serviceYear;
                yearType.value = ele.serviceYear;
            }
        })
        if (actionButtonData.statusId === 2) {
            history.push({
                pathname: '/menu/checkListUltimate',
                state: { tempYear }
            });
        }

        if (actionButtonData.statusId === 6) {
            userType.value = 'L2 Checklist';
            history.push({
                pathname: '/menu/checkListUltimate',
                state: { tempYear }
            });
        }

        if (actionButtonData.statusId === 17) {
            history.push('/menu/client-draft-document');
        }

        if (actionButtonData.statusId === 20) {
            history.push('/menu/client-tax-payment');
        }

        if (actionButtonData.statusId === 22 ||
            actionButtonData.statusId === 23 ||
            actionButtonData.statusId === 24 ||
            actionButtonData.statusId === 25 ||
            actionButtonData.statusId === 26 ||
            actionButtonData.statusId === 30 ||
            actionButtonData.statusId === 31
        ) {
            history.push('/menu/client-final-doc-approval');
        }
    };

    const getStatus = (data) => {
        let itrReturn;
        if (data.Statusid === 2 || data.Statusid === 6) {
            itrReturn = (
                <button className="checklistBtn-openService" onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId }, data)}>
                    {data.Statusid === 2 ? "Submit L1" : "Submit L2"}
                </button>
            );
        }
        if (data.Statusid === 17) {
            itrReturn = (
                <button className="checklistBtn-openService" onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId }, data)}>
                    {/* Review Draft <br></br>computation */}
                    Review draft statements
                </button>
            );
        }
        if (data.Statusid === 20) {
            itrReturn = (
                <button className="checklistBtn-openService" onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId }, data)}>
                    {/* Tax Payment <br></br>Approval */}
                    Pay/transfer the tax amount
                </button>
            );
        }

        if (data.Statusid === 22
            || data.Statusid === 23
            || data.Statusid === 24
            || data.Statusid === 25
            || data.Statusid === 26
            || data.Statusid === 30
            || data.Statusid === 31) {
            itrReturn = (
                <button className="checklistBtn-openService" onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId }, data)}>
                    {/* Final computation <br></br>Approval */}
                    {/* Tax payment Document */}
                    View report
                </button>
            );
        }

        return itrReturn;
    };

    const pagination = (propsPagination) => {
        handleCount(propsPagination);
    };

    const pagin = () => {
        const pag = (
            <div
                style={{
                    float: "right",
                    padding: " 16px",
                    display: "flex",
                    alignItems: "baseline",
                }}>
                <div style={{ marginLeft: "10px", paddingBottom: "6px" }}>
                    Showing {pageDetails && pageDetails.number + 1} of {pageDetails && pageDetails.totalPages} Pages
                </div>

                {pageDetails && pageDetails.totalPages > 1 ?
                    <>
                        <button
                            className="checklistBtn-openService PNButton"
                            onClick={() => pagination("prev")}
                            disabled={prvnxtbt.prvBt}>
                            Previous
                </button>

                        <button
                            className="checklistBtn-openService PNButton"
                            onClick={() => pagination("next")}
                            disabled={prvnxtbt.nxtBt}>
                            Next
                </button>
                    </>
                    : ''
                }

            </div>
        );
        return pag;
    };

    const rowData = (rowdata, serviceType) => {
        return headcells.map((col) => {
            let tabledata;
            const checkList = rowdata.checkList ? rowdata.checkList.currentStage : '';
            if (col.id === 'statusId' && serviceType === 'ultimateopen' && checkList.id !== 0) {
                tabledata = (
                    <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                        {(checkList.id !== 2) && (checkList.id !== 6) && (checkList.id !== 17) && (checkList.id !== 20)
                            && (checkList.id !== 22)
                            && (checkList.id !== 23)
                            && (checkList.id !== 24)
                            && (checkList.id !== 25)
                            && (checkList.id !== 26)
                            && (checkList.id !== 30)
                            && (checkList.id !== 31)
                            ? checkList.stageText : ''}
                        {getStatus({ Statusid: checkList.id, servId: rowdata['serviceId'], chklstData: checkList })}
                    </TableCell>
                );
            } else {
                if (col.isConcat && rowdata[col.id]) {
                    const subdata = rowdata[col.id];
                    const mergedData = col.concatElem.map((concatdata) => {
                        return concatdata.split('.').reduce((acc, item) => {
                            if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                return acc[item];
                            }
                            return '';
                        }, subdata);
                    });
                    return (
                        <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                            {mergedData.join(' ')}
                        </TableCell>
                    );
                }
                tabledata = (
                    <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                        {rowdata[col.id]}
                    </TableCell>
                );
            }

            return tabledata;
        });
    };

    return (
        <div className={classes.root}>
            <TableContainer>
                <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                    <EnhancedTableHead
                        classes={classes}
                        headcells={headcells}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        action={action}
                    />

                    <TableBody style={{ fontFamily: 'Rubik' }}>
                        {stableSort(rows, getComparator(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                const rowDataShow = rowData(row, service);
                                let slno = 1;
                                if (page > 0) {
                                    slno = rowsPerPage * page + 1;
                                }
                                slno += index;

                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={slno}
                                        className={classes.tableRow}
                                        onClick={() => handleClickRow(row)}
                                    >
                                        {rowDataShow}
                                        {action && (
                                            <TableCell align="left" className={classes.tblAction}>
                                                <FormDialog row={row} pageName={pageName} show="editIcon" />
                                                <CommentDeleting row={row} post={post} deleteRow={handleDelete} comments />
                                            </TableCell>
                                        )}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item sm={12}>
                {pagin()}
            </Grid>
        </div>
    );
};

export default ServiceTableClient;
